import { toCompact, type SharePayload } from './share-payload';
import { deflateRaw, bytesToBase64Url } from './deflate-base64url';

export async function encodeShare(payload: SharePayload): Promise<string> {
  const json = JSON.stringify(toCompact(payload));
  const bytes = new TextEncoder().encode(json);
  const deflated = await deflateRaw(bytes);
  return bytesToBase64Url(deflated);
}
